import Spinner from '@/_application/core/components/ui/loaders/spinner/spinner';
import {SearchIcon} from '@/_application/icons/search-icon';
import SearchView from '@/_application/modules/products/components/search/search-view-mobile';
import useProductSearch from '@/_application/modules/products/hooks/use-product-search';
import {Combobox} from '@headlessui/react';
import {isSearchLoadingAtom} from '@/store/search-atom';
import {useAtom} from 'jotai';

function MiniSearchHeader() {
    const [isLoading] = useAtom(isSearchLoadingAtom);
    const {isSearchPage, searchQuery, handleSearch, onSelect, handleEnterPress, handleOnChange} = useProductSearch();

    return (
        <div className="relative flex h-8 w-3/5 items-center rounded-full bg-white">
            <Combobox value={searchQuery} onChange={onSelect}>
                <Combobox.Input
                    autoFocus={isSearchPage}
                    onChange={handleOnChange}
                    onKeyDown={handleEnterPress}
                    displayValue={() => searchQuery}
                    placeholder="Ba mẹ tìm kiếm gì cho con hôm nay"
                    className="ml-2 h-8 w-full overflow-hidden rounded-full border-none bg-white text-sm font-normal focus:outline-none focus:ring-0"
                />
                <button
                    onClick={() => handleSearch(searchQuery)}
                    className="transition-opacity hover:opacity-80"
                    aria-label="Tìm kiếm">
                    {searchQuery && isLoading ? (
                        <Spinner simple className="mr-3 h-5 w-5" />
                    ) : (
                        <SearchIcon className="mr-3 h-5 w-5 cursor-pointer text-gray-400/60" />
                    )}
                </button>
                {searchQuery && <SearchView searchQuery={searchQuery} />}
            </Combobox>
        </div>
    );
}

export default MiniSearchHeader;
